<!-- TODO: can we hide close button on showConfirmDeletion? Or does the close button need to be pulled into here? -->
<button
  class="icon-delete-button"
  aria-label="Delete photo"
  *ngIf="!showConfirmDeletion"
  (keyup.enter)="deleteImageIntent()"
  (keyup.space)="deleteImageIntent()"
  (click)="deleteImageIntent()">
  <svg-icon class="icon-delete" src="assets/icons/trash.svg"></svg-icon>
</button>
<kp-carousel class="image-carousel" [options]="sliderOptions" [plugins]="[MutationPlugin, ResizePlugin]">
  <div class="carousel-image-wrap" *ngFor="let image of images">
    <img
      class="carousel-image"
      [src]="image?.urlOptimized"
      [alt]="'Uploaded image, original filename was ' + image?.originalFilename" />
  </div>
</kp-carousel>
<kp-bottom-arrow-nav
  class="bottom-nav"
  *ngIf="!showConfirmDeletion"
  [showsBackButton]="showNavButtons"
  (backClick)="slider?.prev?.()"
  backAriaLabel="Previous image"
  [showsNextButton]="showNavButtons"
  (nextClick)="slider?.next?.()"
  nextAriaLabel="Next image"
  [showsContent]="true"
  [showFade]="false">
  <a routerLink="/me/photos" class="link-view-all" aria-label="View all user images" (click)="checkCurrentPage($event)">
    View All
  </a>
</kp-bottom-arrow-nav>

<div *ngIf="showConfirmDeletion" class="confirm-deletion-popup">
  <p class="confirm-remove-question" aria-live="polite">
    Are you sure you want to remove this image from {{ product }}?
  </p>
  <div class="delete-confirmation-buttons">
    <button
      class="button-delete-cancel"
      aria-label="Cancel image deletion"
      (keyup.enter)="deleteImage(false)"
      (keyup.space)="deleteImage(false)"
      (click)="deleteImage(false)"
      [disabled]="deletingImage">
      Cancel
    </button>
    <button
      class="button button-pill button-reverse button-w-icon button-delete-confirm"
      aria-label="Remove image"
      (keyup.enter)="deleteImage(true)"
      (keyup.space)="deleteImage(true)"
      (click)="deleteImage(true)"
      [disabled]="deletingImage">
      <svg-icon src="assets/icons/trash.svg" class="button-icon"></svg-icon>
      <span>Remove</span>
    </button>
  </div>
</div>
